import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=47d4de56&"
import script from "./Logo.js?vue&type=script&lang=js&"
export * from "./Logo.js?vue&type=script&lang=js&"
import style0 from "./Logo.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports